import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isTags(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.TAGS && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
function _formatTags(_ref) {
  let {
    field,
    value
  } = _ref;
  if (value.length === 0) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatTags(submission) {
  if (isTags(submission)) {
    return _formatTags(submission);
  }
  return undefined;
}
//# sourceMappingURL=tags-preview.js.map